var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.LoginFlowContainer,{attrs:{"heading":_setup.t('core', 'Account connected')}},[_c(_setup.NcNoteCard,{attrs:{"type":"info"}},[_vm._v("\n\t\t"+_vm._s(_setup.t('core', 'Your client should now be connected!'))+"\n\t\t"),_c('br'),_vm._v("\n\t\t"+_vm._s(_setup.t('core', 'You can close this window.'))+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }